import { render } from "./simpleRow.vue?vue&type=template&id=2dce6900&scoped=true"
import script from "./simpleRow.vue?vue&type=script&lang=js"
export * from "./simpleRow.vue?vue&type=script&lang=js"

import "./simpleRow.vue?vue&type=style&index=0&id=2dce6900&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2dce6900"]])

export default __exports__